import React from 'react'

import { useTranslation } from 'react-i18next'

import PageRoutes from '@utils/page-routes'

const PremiumAd: React.FC = () => {
  const { t } = useTranslation()

  return (
    <a href={PageRoutes.premiumTrialPath()}>
      <div className="border-2 rounded-sm border-orange 600 py-4 px-5 mt-4 text-center bg-white dark:bg-black-bg2">
        <p className="text-orange text-lg font-semibold mb-1">{t('content.premiumAd1')}</p>
        <p>{t('content.premiumAd2b')}</p>
      </div>
    </a>
  )
}

export default PremiumAd
